<template>
  <div>
    <v-card
      ><v-card-text>
        <menuSuperviseur />
        <v-card flat>
          <div class="text-center mt-4">
            <v-chip
              v-for="(item, i) in regions"
              :key="i"
              class="ma-2"
              color="primary"
              >{{ item.ll_region }}</v-chip
            >
          </div>

          <v-card-actions>
            <v-container fluid>
              <v-row align="center">
                <v-col class="my-0 py-0">
                  <v-menu
                    v-model="menuStart"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="computedStart"
                        label="Début"
                        prepend-icon="mdi-calendar-cursor"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="requis"
                        required
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="fr"
                      v-model="start"
                      no-title
                      @input="menuStart = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="my-0 py-0">
                  <v-menu
                    v-model="menuEnd"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="computedEnd"
                        label="Fin"
                        prepend-icon="mdi-calendar-cursor"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="requis"
                        required
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="fr"
                      v-model="end"
                      no-title
                      @input="menuEnd = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col class="my-0 py-0">
                  <v-autocomplete
                    @change="buildrequest()"
                    v-model="projetSelected"
                    :items="projets"
                    outlined
                    dense
                    label="Projets"
                    item-text="ll_programme"
                    item-value="id"
                    deletable-chips
                    small-chips
                  ></v-autocomplete>
                </v-col>
                <v-col class="my-0 py-0">
                  <v-autocomplete
                    @change="buildrequest()"
                    v-model="activiteSelected"
                    :items="activitesFiltered"
                    outlined
                    dense
                    label="Activites"
                    item-text="ll_parcours"
                    item-value="id"
                    deletable-chips
                    small-chips
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col class="my-0 py-0">
                  <v-autocomplete
                    style="width: 390px;"
                    @change="buildrequest()"
                    v-model="animateurSelected"
                    :items="animateursDeProjets"
                    outlined
                    dense
                    label="Animateurs"
                    item-text="displayName"
                    item-value="id"
                    deletable-chips
                    small-chips
                  ></v-autocomplete>
                </v-col>
                <v-col class="my-0 py-0">
                  <v-autocomplete
                    @change="buildrequest()"
                    v-model="etapeSelected"
                    :items="etapesFiltered"
                    outlined
                    dense
                    label="Etapes"
                    item-text="ll_etape"
                    item-value="id"
                    deletable-chips
                    small-chips
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="text-right my-0 py-0">
                  <vue-excel-xlsx
                    class="mr-4"
                    v-if="etapesEffectivesDeRegion.length > 0"
                    :data="etapesEffectivesDeRegion"
                    :columns="headers"
                    :filename="'activites_' + Date.now()"
                    :sheetname="'activites'"
                  >
                    <v-btn class="primary" dark>
                      <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                      Télécharger les
                      {{ etapesEffectivesDeRegion.length }} Activités</v-btn
                    >
                  </vue-excel-xlsx>
                </v-col>
                <v-col class="text-right my-0 py-0">
                  <v-btn
                    @click="getEtapesEffectivesByIdEtape(regionSupervisees)"
                    class="mr-4"
                    color="primary"
                    :loading="loading"
                  >
                    Afficher Activités
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
          <v-card-text>
            <div>
              Total Femmes :
              {{
                _.sumBy(etapesEffectivesDeRegion, function (o) {
                  return parseInt(o.valueRecapFemmes, 10);
                })
              }}
            </div>
            <div>
              Total Hommes :
              {{
                _.sumBy(etapesEffectivesDeRegion, function (o) {
                  return parseInt(o.valueRecapHommes, 10);
                })
              }}
            </div>
            <!--        <div>
              Total Valeurs :
              {{
                _.sumBy(etapesEffectivesDeRegion, function (o) {
                  return parseInt(o.valueCalcul, 10);
                })
              }}
            </div> -->
          </v-card-text>
          <v-card-text>
            <!--    {{ query.sn.K }}  -->

            <!--  <div>{{ request }}</div> -->
            <v-tabs v-model="tab" centered>
              <v-tabs-slider></v-tabs-slider>

              <v-tab href="#totaux">
                Liste des fiches saisies
              </v-tab>

              <v-tab href="#fichesaisies">
                Données Totaux
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item value="fichesaisies">
                <v-data-table
                  :headers="headers"
                  :items="etapesEffectivesDeRegion"
                  :items-per-page="20"
                  class="elevation-1"
                  :search="search"
                  locale="fr"
                  item-key="uuid"
                >
                  <template v-slot:item.valueRecapFemmes="{ item }">
                    {{ toInt(item.valueRecapFemmes) }}
                  </template>
                  <template v-slot:item.valueRecapHommes="{ item }">
                    {{ toInt(item.valueRecapHommes) }}
                  </template>
                </v-data-table>
              </v-tab-item>
              <v-tab-item value="totaux">
                <v-data-table
                  :headers="headersFiche"
                  :items="etapesEffectivesDeRegionParFiche"
                  :items-per-page="20"
                  class="elevation-1"
                  :search="search"
                  locale="fr"
                  item-key="uuid"
                >
                </v-data-table>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <Navigation :elements="SuperviseurNavigation" />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { uuid } from "pouchdb-utils";
import { mapState, mapActions } from "vuex";
export default {
  watch: {
    projetSelected: function (val) {
      let activitesFiltered = _.filter(this.activites, {
        programmes_id_programme: val,
      });
      this.activitesFiltered = activitesFiltered;
    },

    activiteSelected: function (val) {
      let etapesFiltered = _.filter(this.etapes, {
        parcours_id_parcours: val,
      });
      this.etapesFiltered = etapesFiltered;
    },
  },
  created() {
    this.SetProjectList();
    this.getAnimateurs(this.regionSupervisees);
    this.getDetailsRegionsSupervisees(this.listeRegionsSupervisees);
    this.getProjets();
    this.getActivites();
    this.getEtapes();
  },
  data() {
    return {
      etapesEffectivesDeRegion: [],
      etapesEffectivesDeRegionParFiche: [],
      ProjetctList: [],
      tab: "fichesaisies",
      search: "",
      dialogEditFormation: false,
      dialogCheckGroupe: false,
      formationSelected: { ll_formation_groupe: "", date_formation_groupe: "" },
      menu2: false,
      regions: [],
      query: { sn: { K: {} } },
      request: {
        projets: null,
        animateurs: null,
        activites: null,
        etapes: null,
      },
      requis: [
        (v) => !!v || "Ce champ est obligatoire",
        (v) => (v && v.length >= 3) || "Au moins trois caractères",
      ],
      loading: false,
      menuStart: false,
      menuEnd: false,
      start: this.$moment(Date.now()).subtract(1, "year").format("YYYY-MM-DD"),
      end: this.$moment(Date.now()).format("YYYY-MM-DD"),
      headers: [
        {
          text: "Groupe",
          value: "nom_groupe",
          label: "Groupe",
          field: "nom_groupe",
        },

        {
          text: "Projet",
          value: "ll_programme",
          label: "Projet",
          field: "ll_programme",
        },

        {
          text: "Campagne",
          value: "ll_parcours_effectif",
          label: "Campagne",
          field: "ll_parcours_effectif",
        },

        {
          text: "Activité",
          value: "ll_parcours",
          label: "Activité",
          field: "ll_parcours",
        },
        {
          text: "Etape",
          value: "ll_etape",
          label: "Etape",
          field: "ll_etape",
        },

        {
          text: "Détail Etape",
          value: "ll_details_etapes",
          label: "Détail Etape",
          field: "ll_details_etapes",
        },

        {
          text: "Totaux Femmes",
          value: "valueRecapFemmes",
          label: "Femmes",
          field: "valueRecapFemmes",
          dataFormat: this.toInt,
        },
        {
          text: "Totaux Hommes",
          value: "valueRecapHommes",
          label: "Hommes",
          field: "valueRecapHommes",
          dataFormat: this.toInt,
        },

        {
          text: "Totaux Valeurs",
          value: "valueCalcul",
          label: "Totaux Valeurs",
          field: "valueCalcul",
        },
        {
          text: "Statut",
          value: "status",
          label: "Statut",
          field: "status",
        },
        {
          text: "Animateur",
          value: "nom_responsable",
          label: "Animateur",
          field: "nom_responsable",
        },

        {
          text: "Région",
          value: "ll_region",
          label: "Région",
          field: "ll_region",
        },
        {
          text: "District",
          value: "ll_district",
          label: "District",
          field: "ll_district",
        },
        {
          text: "Commune",
          value: "ll_commune",
          label: "Commune",
          field: "ll_commune",
        },
        {
          text: "Fokontany",
          value: "ll_fokontany",
          label: "Fokontany",
          field: "ll_fokontany",
        },

        {
          text: "Mois",
          value: "ll_mois",
          label: "Mois",
          field: "ll_mois",
        },

        {
          text: "Date Insertion",
          value: "date_insert_etape_effective",
          label: "Date Insertion",
          field: "date_insert_etape_effective",
        },
      ],

      headersFiche: [
        {
          text: "Groupe",
          value: "nom_groupe",
          label: "Groupe",
          field: "nom_groupe",
        },

        {
          text: "Projet",
          value: "ll_programme",
          label: "Projet",
          field: "ll_programme",
        },

        {
          text: "Campagne",
          value: "ll_parcours_effectif",
          label: "Campagne",
          field: "ll_parcours_effectif",
        },

        {
          text: "Activité",
          value: "ll_parcours",
          label: "Activité",
          field: "ll_parcours",
        },
        {
          text: "Etape",
          value: "ll_etape",
          label: "Etape",
          field: "ll_etape",
        },

        {
          text: "Animateur",
          value: "nom_responsable",
          label: "Animateur",
          field: "nom_responsable",
        },

        {
          text: "Région",
          value: "ll_region",
          label: "Région",
          field: "ll_region",
        },
        {
          text: "District",
          value: "ll_district",
          label: "District",
          field: "ll_district",
        },
        {
          text: "Commune",
          value: "ll_commune",
          label: "Commune",
          field: "ll_commune",
        },
        {
          text: "Fokontany",
          value: "ll_fokontany",
          label: "Fokontany",
          field: "ll_fokontany",
        },

        {
          text: "Mois",
          value: "ll_mois",
          label: "Mois",
          field: "ll_mois",
        },

        {
          text: "Date Insertion",
          value: "date_insert_etape_effective",
          label: "Date Insertion",
          field: "date_insert_etape_effective",
        },
      ],

      formationsDeGroupeRegion: [],
      MembresFormationsDeGroupeRegion: [],
      projetSelected: null,
      animateurSelected: null,
      activiteSelected: null,
      activitesFiltered: [],
      etapeSelected: null,
      etapesFiltered: [],
      formationSelectionnee: null,
      groupeFromFormation: null,
    };
  },
  components: {
    menuSuperviseur: require("@/components/superviseur/menuSuperviseur.vue")
      .default,
    Navigation: require("@/components/Navigation.vue").default,
  },
  methods: {
    toInt(value) {
      return parseInt(value, 10);
    },
    ...mapActions({
      GetArrayRegions: "Utils/GetArrayRegions",
      getAnimateurs: "Users/getAnimateurs",
      getActivites: "Activites/GetAll",
      getProjets: "Projets/getListeProjets",
      getEtapes: "Etapes/GetAll",
    }),

    SetProjectList() {
      this.ProjetctList = Array.isArray(this.user.projets)
        ? this.user.projets.map((projet) => projet.id)
        : [];
    },

    getSexe(sexe) {
      if (sexe == "1") {
        return "Masculin";
      } else {
        return "Féminin";
      }
    },

    // fin edition et suppression de formation
    buildrequest() {
      this.request.projets = this.projetSelected;
      this.request.animateurs = this.animateurSelected;
      this.request.activites = this.activiteSelected;
      this.request.etapes = this.etapeSelected;
      console.log("request :", this.request);
    },
    setActivites() {
      console.log("setActivites");
    },

    getDetailsRegionsSupervisees(regionSupervisees) {
      let self = this;
      this.$firebase
        .firestore()
        .collection("regions")
        .where("id", "in", regionSupervisees)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            self.regions.push({
              ...doc.data(),
              id: doc.id,
            });
          });
          console.log(self.regions);
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    },

    getEtapesEffectivesByIdEtape(arrayRegions) {
      let self = this;
      self.etapesEffectivesDeRegion = [];
      self.etapesEffectivesDeRegionParFiche = [];
      self.$vloading.show();

      var ref = this.$firebase.firestore().collection("etapes_effectives");
      let query = ref.where("id_region", "in", arrayRegions);
      //.where("date_formation_groupe", ">=", self.start)
      //.where("date_formation_groupe", "<=", self.end);

      //Animateur
      console.log("Animateur ****** :", this.request.animateurs);
      if (this.request.animateurs) {
        query = query.where(
          "id_responsable",
          "==",
          this.request.animateurs.toString()
        );
        console.log("Animateur :", this.request.animateurs);
      }
      //Etape
      console.log("Etape ****** :", this.request.etapes);
      if (this.request.etapes) {
        query = query.where(
          "etape_id_etape",
          "==",
          this.request.etapes.toString()
        );
        console.log("Etape :", this.request.etapes);
      }

      //Activites
      if (this.request.activites) {
        console.log("activiteSelected : ", this.activiteSelected);
        query = query.where(
          "parcours_id_parcours",
          "==",
          this.request.activites.toString()
        );
      } else {
        //Projet
        if (this.request.projets) {
          query = query.where(
            "programmes_id_programme",
            "==",
            this.request.projets.toString()
          );
          console.log("Projets :", this.request.projets);
        }
      }

      self.query = query.xd;
      //query final
      var tabTemp = [];

      const results = query
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc, index) => {
            var etapeEffective = doc.data();

            if (etapeEffective.recapVerified) {
              var total = 0;

              etapeEffective.recapVerified.forEach(function (recap, idx) {
                //valueRecapHommes: 0,
                ///valueCalcul: 0,
                //valueRecapFemmes: 0,
                var tot =
                  parseFloat(recap.valueRecapHommes) +
                  parseFloat(recap.valueRecapFemmes) +
                  parseFloat(recap.valueCalcul);
                //console.log("toooo", tot)

                if (tot !== 0) {
                  tabTemp.push({
                    ...recap,
                    ...doc.data(),
                    uuid: uuid(),
                  });
                }

                total = total + tot;
              });
            } else {
              var recap = {
                valueRecapHommes: 0,
                valueCalcul: 0,
                valueRecapFemmes: 0,
                status: "NC",
              };

              var tot =
                parseFloat(recap.valueRecapHommes) +
                parseFloat(recap.valueRecapFemmes) +
                parseFloat(recap.valueCalcul);

              if (tot !== 0) {
                tabTemp.push({
                  ...recap,
                  ...doc.data(),
                  uuid: uuid(),
                });
              }
            }

            if (total !== 0) {
              self.etapesEffectivesDeRegionParFiche.push({ ...doc.data() });
            }

            self.etapesEffectivesDeRegion = tabTemp;
          });

          //self.request = { projets: null, animateurs: null, activites: null };
          /*  self.projetSelected = null;
            self.animateurSelected = null;
            self.activiteSelected = null; */
          self.$vloading.hide();
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    },
  },

  computed: {
    computedDateFormation() {
      return this.formationSelected.date_formation_groupe
        ? this.$moment(this.formationSelected.date_formation_groupe).format(
            "DD-MM-YYYY"
          )
        : "";
    },
    computedStart() {
      return this.start ? this.start : "";
    },
    computedEnd() {
      return this.end ? this.end : "";
    },
    ...mapState({
      user: (state) => state.Auth.user,
      //projets: (state) => state.Projets.projets,
      projets: (state) => state.Auth.user.projets,
      activites: (state) => state.Activites.Activites,
      etapes: (state) => state.Etapes.Etapes,
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
      regionSupervisees: (state) => state.Utils.listeRegionsSupervisees,
      animateursDeRegions: (state) => state.Users.animateursDeRegions,
      listeRegionsSupervisees: (state) => state.Utils.listeRegionsSupervisees,
      isSuperviseur: (state) => state.Auth.isSuperviseur,
      isOperateur: (state) => state.Auth.isOperateur,
      animateursDeProjets(state) {
        return state.Users.animateursDeRegions.filter((u) => {
          const projets = Array.isArray(u.projets) ? u.projets : [];
          return projets.some((d) => _.includes(this.ProjetctList, d.id));
        });
      },
    }),
  },
};
</script>

<style lang="scss" scoped></style>
